
<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Inventory Management</h2>
        <can I="create" a="installation"></can>
        <!-- <a class="btn btn-primary" :href="productReg+`${getRegUri(getUserSession.id)}`">
          Create Request &nbsp;
          <span class="fa fa-plus"></span>
        </a>-->
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <el-tabs v-model="activeTab">
              <!-- <can I='read' a='inventory'>
                <el-tab-pane label="Inventory Overview" name="inventory_overview">
                  <Inventory></Inventory>
                </el-tab-pane>
              </can>-->
              <can I="create" a="inventory">
                <el-tab-pane label="Components" name="inventory_component">
                  <InventoryComponent></InventoryComponent>
                </el-tab-pane>
              </can>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Button,
  Form,
  FormItem
  // ...
} from "element-ui";
import Inventory from "../inventory/index";
import InventoryComponent from "../inventory/components";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
export default {
  name: "",
  components: {
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "el-form": Form,
    "el-form-item": FormItem,
    Inventory,
    InventoryComponent
  },
  data() {
    return {
      activeTab: "inventory_component",
      showOffCanvas: false,
      showAddInventoryModal: false,
      multiple: true,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null,
        type: "component",
        userId: 0
      },
      serialForm: {
        min: null,
        max: null
      },
      getComponentName(param) {
        try {
          return this.componentOptions.filter(x => x.value == param)[0].name;
        } catch (error) {
          return "";
        }
      },
      componentOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component"
        }
      ],
      componentTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component type"
        }
      ]
    };
  },
  computed: {},
  methods: {
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    fetchComponentTypes(selectedCompId) {
      console.log(selectedCompId);
      if (selectedCompId !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/components/${selectedCompId}/componentTypes`;
        HTTP.get(url).then(response => {
          const componentList = response.data;
          componentList.filter(x => {
            x.value = x.id;
            x.text = x.name;
          });
          context.componentTypeOptions = [
            ...context.componentTypeOptions,
            ...componentList
          ];
        });
      }
    },
    addInventory() {
      let url = "/inventories";
      if (this.multiple) {
        this.componentForm.serialNumber = `${this.serialForm.min}->${this.serialForm.max}`;
        url = "/inventories/multiple";
      }
      if (this.validateRequestForm() === true) {
        this.componentForm.userId = this.getUserSession.id;
        const container = this;
        const HTTP = this.$httpUtils.instance;
        HTTP.post(url, this.componentForm)
          .then(response => {
            container.showSuccessMsg({
              message: response.data + "\nComponent(s) Added"
            });
            container.hideModal();
            container.getComponents();
          })
          .catch(error => {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = Object.keys(errorMsg);
            Object.values(errorMsg).map((x, index) => {
              errTemp[index] = keyHooks[index] + " " + x[0];
            });
            errTemp = Object.values(errTemp).join("<br>");
            container.showErrorMsg({
              message: errTemp
            });
          });
      } else {
        this.showErrorMsg({
          message: this.validateRequestForm()
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/inventory.vue